import { useState, useRef, useEffect } from "react";
import { getPortalDocument } from "../../../dev/ThemeManager/utils";

interface DragOffset {
  x: number;
  y: number;
}

interface UseDraggableReturn {
  dragOffset: DragOffset;
  isDragging: boolean;
  handleMouseDown: (e: React.MouseEvent) => void;
}

export const useDraggable = (): UseDraggableReturn => {
  const [dragOffset, setDragOffset] = useState<DragOffset>({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartPos = useRef({ x: 0, y: 0 });

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    dragStartPos.current = {
      x: e.clientX - dragOffset.x,
      y: e.clientY - dragOffset.y,
    };
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      setDragOffset({
        x: e.clientX - dragStartPos.current.x,
        y: e.clientY - dragStartPos.current.y,
      });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      // Use portal document (parent when in iframe) for event listeners
      // This ensures drag events work when panel is portaled outside iframe
      const portalDoc = getPortalDocument();
      portalDoc.addEventListener("mousemove", handleMouseMove);
      portalDoc.addEventListener("mouseup", handleMouseUp);

      return () => {
        portalDoc.removeEventListener("mousemove", handleMouseMove);
        portalDoc.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [isDragging]);

  return { dragOffset, isDragging, handleMouseDown };
};
